import BannerSwiper from '@/components/swiper/BannerSwiper.vue';
import { $httpChangiRecommends } from '@/core/api';
import Vue from 'vue';
export default Vue.extend({
    components: { BannerSwiper },
    data() {
        return {
            banners: [],
        };
    },
    created() {
        $httpChangiRecommends.api.ChangiRecommendsSLiders().then((resp) => {
            this.banners = resp.data;
        });
    },
});
